 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781847677440_COVER from '@/components/9781847677440_cover'
 import A781847677440_ABOUTTHEAUTHOR from '@/components/9781847677440_abouttheauthor'
 import LOVE_1 from '@/components/love_1'
 import A781847677440_BOOKTITLEPAGE from '@/components/9781847677440_booktitlepage'
 import A781847677440_INSERTEDCOPYRIGHT from '@/components/9781847677440_insertedcopyright'
 import A781847677440_OTHER_01 from '@/components/9781847677440_other_01'
 import A781847677440_DEDICATION from '@/components/9781847677440_dedication'
 import A781847677440_EPIGRAPH from '@/components/9781847677440_epigraph'
 import A781847677440_TABLEOFCONTENTS from '@/components/9781847677440_tableofcontents'
 import A781847677440_INTRO from '@/components/9781847677440_intro'
 import A781847677440_INTRODUCTION from '@/components/9781847677440_introduction'
 import A781847677440_CHAPTER_01 from '@/components/9781847677440_chapter_01'
 import A781847677440_CHAPTER_02 from '@/components/9781847677440_chapter_02'
 import A781847677440_CHAPTER_03 from '@/components/9781847677440_chapter_03'
 import A781847677440_PART_01 from '@/components/9781847677440_part_01'
 import A781847677440_PART_02 from '@/components/9781847677440_part_02'
 import A781847677440_PART_03 from '@/components/9781847677440_part_03'
 import A781847677440_CHAPTER_04 from '@/components/9781847677440_chapter_04'
 import A781847677440_CHAPTER_05 from '@/components/9781847677440_chapter_05'
 import A781847677440_CHAPTER_06 from '@/components/9781847677440_chapter_06'
 import A781847677440_CHAPTER_07 from '@/components/9781847677440_chapter_07'
 import A781847677440_CHAPTER_08 from '@/components/9781847677440_chapter_08'
 import A781847677440_CHAPTER_09 from '@/components/9781847677440_chapter_09'
 import A781847677440_CHAPTER_10 from '@/components/9781847677440_chapter_10'
 import A781847677440_CHAPTER_11 from '@/components/9781847677440_chapter_11'
 import A781847677440_CHAPTER_12 from '@/components/9781847677440_chapter_12'
 import A781847677440_CHAPTER_13 from '@/components/9781847677440_chapter_13'
 import A781847677440_CHAPTER_14 from '@/components/9781847677440_chapter_14'
 import A781847677440_CHAPTER_15 from '@/components/9781847677440_chapter_15'
 import A781847677440_CHAPTER_16 from '@/components/9781847677440_chapter_16'
 import A781847677440_CHAPTER_17 from '@/components/9781847677440_chapter_17'
 import A781847677440_CHAPTER_18 from '@/components/9781847677440_chapter_18'
 import A781847677440_CHAPTER_19 from '@/components/9781847677440_chapter_19'
 import A781847677440_CHAPTER_20 from '@/components/9781847677440_chapter_20'
 import A781847677440_CHAPTER_21 from '@/components/9781847677440_chapter_21'
 import A781847677440_CHAPTER_22 from '@/components/9781847677440_chapter_22'
 import A781847677440_CHAPTER_23 from '@/components/9781847677440_chapter_23'
 import A781847677440_CHAPTER_24 from '@/components/9781847677440_chapter_24'
 import A781847677440_CHAPTER_25 from '@/components/9781847677440_chapter_25'
 import A781847677440_CHAPTER_26 from '@/components/9781847677440_chapter_26'
 import A781847677440_CHAPTER_27 from '@/components/9781847677440_chapter_27'
 import A781847677440_CHAPTER_28 from '@/components/9781847677440_chapter_28'
 import A781847677440_CHAPTER_29 from '@/components/9781847677440_chapter_29'
 import A781847677440_CHAPTER_30 from '@/components/9781847677440_chapter_30'
 import A781847677440_CHAPTER_31 from '@/components/9781847677440_chapter_31'
 import A781847677440_CHAPTER_32 from '@/components/9781847677440_chapter_32'
 import A781847677440_CHAPTER_33 from '@/components/9781847677440_chapter_33'
 import A781847677440_CHAPTER_34 from '@/components/9781847677440_chapter_34'
 import A781847677440_CHAPTER_35 from '@/components/9781847677440_chapter_35'
 import A781847677440_CHAPTER_36 from '@/components/9781847677440_chapter_36'
 import A781847677440_CHAPTER_37 from '@/components/9781847677440_chapter_37'
 import A781847677440_CHAPTER_38 from '@/components/9781847677440_chapter_38'
 import A781847677440_CHAPTER_39 from '@/components/9781847677440_chapter_39'
 import A781847677440_CHAPTER_40 from '@/components/9781847677440_chapter_40'
 import A781847677440_CHAPTER_41 from '@/components/9781847677440_chapter_41'
 import A781847677440_CHAPTER_42 from '@/components/9781847677440_chapter_42'
 import A781847677440_CHAPTER_43 from '@/components/9781847677440_chapter_43'
 import A781847677440_CHAPTER_44 from '@/components/9781847677440_chapter_44'
 import A781847677440_CHAPTER_45 from '@/components/9781847677440_chapter_45'
 import A781847677440_CHAPTER_46 from '@/components/9781847677440_chapter_46'
 import A781847677440_CHAPTER_47 from '@/components/9781847677440_chapter_47'
 import A781847677440_CHAPTER_48 from '@/components/9781847677440_chapter_48'
 import A781847677440_CHAPTER_49 from '@/components/9781847677440_chapter_49'
 import A781847677440_CHAPTER_50 from '@/components/9781847677440_chapter_50'
 import A781847677440_CHAPTER_51 from '@/components/9781847677440_chapter_51'
 import A781847677440_CHAPTER_52 from '@/components/9781847677440_chapter_52'
 import A781847677440_CHAPTER_53 from '@/components/9781847677440_chapter_53'
 import A781847677440_CHAPTER_54 from '@/components/9781847677440_chapter_54'
 import LOVE_2 from '@/components/love_2'
 import ADS from '@/components/ads'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781847677440_tableofcontents",
 			"name" : "9781847677440_tableofcontents",
 			"component" : A781847677440_TABLEOFCONTENTS
 		},
 		{
 			"path" : "/9781847677440_intro",
 			"name" : "9781847677440_intro",
 			"component" : A781847677440_INTRO
 		},
 		{
 			"path" : "/9781847677440_introduction",
 			"name" : "9781847677440_introduction",
 			"component" : A781847677440_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js